import { ResolveFn } from '@angular/router';
import { MachineService } from 'src/app/shared/services/machine.service';
import { inject } from '@angular/core';
import { ResolverCacheService } from 'src/app/shared/services/resolver-cache.service';
import { MachineDto } from 'src/app/shared/dtos/machine.dto';

export const machineResolver: ResolveFn<MachineDto | null> = (route) => {
  const machineService = inject(MachineService);
  const resolverCacheService = inject(ResolverCacheService);
  const id = route.paramMap.get('machine-id');

  return resolverCacheService.createCachedResolverWithParam<MachineDto | null>(
    'machine',
    id!,
    () => machineService.getMachine(id!)
  );
};
